export const InvStatusEnum = Object.freeze({
    Draft: 8,
    Completed: 9,
    FullyPaid: 10,
    PartiallyPaid: 11,
    SenttoFMS: 12,
    ParentApproved: 13,
    ICCApproved: 14,
    SentforApproval: 15,
    InternalRejected: 16,
    ParentRejected: 17,
    Approved: 42,
    Returned: 43,
    Rejected: 44,
    SentforParentApproval: 45,
    PartialPaymentRecd: 46,
    FullPaymentRecd: 47,
    PartiallySettled: 48,
    FullySettled:49
});


